export class TrainerApproveAllModel {
	SupervisorId: string;
	StudentId: string;
	Remark: string;
	Action: string;
}
